/**
 * Utility functions for handling segment flairs
 */

/**
 * Get flairs for a segment based on its type
 * @param {string} segmentType - The type of segment
 * @param {string} borderColor - The border color of the segment
 * @returns {Array} - Array of flair objects with label, action, and color
 */
export const getFlairsForSegmentType = (segmentType, borderColor) => {
  const typeLC = segmentType.toLowerCase();
  
  // Default flairs for all types - using the segment's border color
  const commonFlairs = [
    { label: 'Quicken', action: 'speed-up', color: borderColor },
    { label: 'Slow', action: 'slow-down', color: borderColor },
    { label: 'Stagger', action: 'stagger', color: borderColor },
    { label: 'Synchronize', action: 'synchronize', color: borderColor },
    { label: 'Emphasize', action: 'emphasize', color: borderColor },
    { label: 'Subtle', action: 'subtle', color: borderColor },
  ];
  
  // Type-specific flairs
  if (typeLC.includes('entrance') || typeLC.includes('appear')) {
    return [
      ...commonFlairs,
      { label: 'Delay Start', action: 'delay-start', color: borderColor },
    ];
  } else if (typeLC.includes('icon') || typeLC.includes('image')) {
    return [
      ...commonFlairs,
    ];
  } else if (typeLC.includes('text') || typeLC.includes('typing')) {
    return [
      ...commonFlairs,
      { label: 'Type Faster', action: 'type-faster', color: borderColor },
      { label: 'Show All', action: 'show-all', color: borderColor },
    ];
  } else if (typeLC.includes('finale') || typeLC.includes('exit')) {
    return [
      ...commonFlairs,
      { label: 'Add Bounce', action: 'add-bounce', color: borderColor },
      { label: 'Hold Longer', action: 'hold-longer', color: borderColor },
    ];
  }
  
  // Default case
  return commonFlairs;
};

/**
 * Get visible flairs and overflow flairs
 * @param {Array} flairs - All available flairs
 * @param {number} maxVisible - Maximum number of visible flairs
 * @returns {Object} - Object with visibleFlairs and overflowFlairs arrays
 */
export const getVisibleAndOverflowFlairs = (flairs, maxVisible = 3) => {
  if (!flairs || flairs.length <= maxVisible) {
    return {
      visibleFlairs: flairs || [],
      overflowFlairs: []
    };
  }
  
  return {
    visibleFlairs: flairs.slice(0, maxVisible),
    overflowFlairs: flairs.slice(maxVisible)
  };
};
